import React, { useMemo } from 'react';
import { Caption, HeadingMBold } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicesTableCellsStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { translate } from 'components/Translation';
import ConditionalRender from '../../../ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IPrice {
	value: string;
	currency: string;
}

interface IPriceCellProps {
	price: string;
	currency: string;
	offerPrice?: IPrice;
	backgroundColor?: types.newServices.backgroundColor;
	perMonth?: boolean;
}

const PriceCell = ({ price, currency, backgroundColor = 'white', perMonth, offerPrice }: IPriceCellProps) => {
	const classes = useStyles();

	const value = useMemo(() => `${price} ${currency}`, [price, currency]);

	return (
		<div
			className={classNames(classes.cell, {
				[classes[`${backgroundColor}Color`]]: true,
			})}
		>
			<HeadingMBold disableMargin>{value}</HeadingMBold>
			<ConditionalRender
				show={!!perMonth}
				onTrue={() => (
					<Caption color="disabled-light" disableMargin>
						{translate('services.table.per.month')}
					</Caption>
				)}
			/>
			<ConditionalRender
				show={!!offerPrice}
				onTrue={() => (
					<Caption color="disabled-light" disableMargin>
						{translate('services.table.vat-price', String(offerPrice!.value), offerPrice!.currency)}
					</Caption>
				)}
			/>
		</div>
	);
};

export default PriceCell;
